import { SagaIterator } from "@redux-saga/core";
import { call, put, takeLatest } from "redux-saga/effects";
import { PageAlert } from "capitalrx-components";

import apiService from "@/App/service";
import { ActionTypes } from "@/App/constants/actionTypes";
import { getBatchManualClaimActions } from "@/App/actions";

function* getBatchManualClaim(payload: string): Generator {
  return yield apiService({
    url: "/transmission/batch_manual/get",
    method: "POST",
    data: {
      id: payload,
    },
  });
}

export function* getBatchManualClaimWorker(action: ReturnType<typeof getBatchManualClaimActions.getManualClaim>): SagaIterator {
  const { payload } = action;
  const { getManualClaimResults } = getBatchManualClaimActions;
  const { showPageAlert } = PageAlert;

  try {
    const batchManualClaim = yield call(getBatchManualClaim, payload);
    yield put(getManualClaimResults(batchManualClaim));
  } catch (error) {
    const { data: { message = "" } = {} } = error;
    yield put(showPageAlert({ show: true, type: "error", message: message }));
  }
}

export default function* getBatchManualClaimWatcher(): SagaIterator {
  yield takeLatest(ActionTypes.GET_BATCH_TRANSMISSION_MANUAL_CLAIM, getBatchManualClaimWorker);
}
